module.exports = function() {
  return new Worker(__webpack_public_path__ + "b422b2a4c2f55a37eaff.worker.js");
};